import { z } from "zod";
import { type RGB, rgbZodSchema } from "./rgb-color";

type RGBA = RGB & { alpha: number };
const rgbaZodSchema = rgbZodSchema.and(
    z.object({
        alpha: z.number().min(0).max(1),
    }),
);

export { rgbaZodSchema };
export type { RGBA };
